import React, { useState } from 'react';

import clsx from 'clsx';

import { Button } from 'components/Buttons/Button';
import FormHeader from 'prequalificationV2/components/FormHeader';
import Loader from 'components/Loader';
import { ButtonType } from 'enums/ButtonType';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { PreQualificationStep } from 'enums/PreQualificationStep';
import { setPreQualificationStep } from 'prequalificationV2/actions';
import { clearCoBorrower } from 'prequalificationV2/actions/coBorrower';
import { preQualificationApi } from 'prequalificationV2/api/PreQualification/PreQualificationApi';
import { useNavigateAfterUnderwriting } from 'prequalificationV2/hooks/useNavigateAfterUnderwriting';
import * as notificationManager from 'notifications/index';
import { FailureNotificationType } from 'notifications/index';

import styles from './CoBorrowerHasApplication.module.scss';

const CoBorrowerHasApplication = () => {
  const dispatch = useAppDispatch();
  const { handleUnderwritingResult } = useNavigateAfterUnderwriting();

  const { firstName, lastName } = useAppSelector((state) => state.coBorrower);
  const { applicationId } = useAppSelector((state) => state.application);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDecline = async () => {
    try {
      setIsLoading(true);

      const response = await preQualificationApi.skipCoborrower(applicationId as string);

      await handleUnderwritingResult(response);
    } catch (error) {
      notificationManager.notifyFailure(FailureNotificationType.UnknownError);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddCoBorrower = () => {
    dispatch(clearCoBorrower());
    dispatch(setPreQualificationStep(PreQualificationStep.AdditionalCoBorrowerInfo));
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <FormHeader
            title="Your coborrower already has an active loan inquiry in the system"
            classNameWrapper={styles.customFormHeader}
          />
          <div className={styles.infoContainer}>
            <div className={styles.text}>
              Your coborrower ({firstName} {lastName}) already has an active loan inquiry in the system and is not
              eligible to be a coborrower on your loan inquiry. You can either add a new coborrower or decline to
              continue the loan inquiry.
            </div>
          </div>
          <div className={styles.buttonControlContainer}>
            <Button buttonType={ButtonType.Secondary} withArrow onClick={() => handleDecline()}>
              Decline to Continue
            </Button>
            <Button onClick={() => handleAddCoBorrower()}>Continue with Co-borrower</Button>
          </div>
          <div className={clsx(styles.text, styles.marginContainer)}>
            If you feel you need assistance, please contact HFS Financial at 855-931-5733 or{' '}
            <a className={styles.link} href="mailto:info@hfsfin.com">
              info@hfsfin.com
            </a>
            .
          </div>
        </>
      )}
    </>
  );
};

export default CoBorrowerHasApplication;
